import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"

import { GoodsReceiptSortField, SortingOrder } from "@/graphql/codegen/graphql"
import { TabletCheckedInGoodsReceiptsContainer } from "@/screens/Tablet/WarehouseReceiving/CheckedIn"
import { createGoodsReceiptSearchSchema } from "@/screens/WarehouseReceiving/schemas"

export const Route = createFileRoute("/app/tablet/warehouse-receiving/_layout/checked-in")({
  validateSearch: zodValidator(createGoodsReceiptSearchSchema(GoodsReceiptSortField.CheckedInOn, SortingOrder.Desc)),
  component: TabletCheckedInGoodsReceiptsContainer,
})
